import script from "./EcommerceConfiguracionView.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceConfiguracionView.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceConfiguracionView.vue?vue&type=style&index=0&id=ee804a4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee804a4a"]])

export default __exports__